import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/Redux/RootReducer';

const emailSendState = (state: RootState) => state.modalWindows.emailSendModalState;

const currentStep = createSelector(emailSendState, (state) => state.currentStep);

const documentType = createSelector(emailSendState, (state) => state.documentType);

const selectedEmailTemplate = createSelector(emailSendState, (state) => state.selectedEmailTemplate);

const emailPreviewModalData = createSelector(emailSendState, (state) => state.emailPreviewModalData);

const rows = createSelector(emailSendState, (state) => state.emailTemplates);

const selectedTypeNumbers = createSelector(emailSendState, (state) => state.selectedTypeNumbers);

const documentNumbersInfo = createSelector(emailSendState, (state) => state.documentNumbersInfo);

const selectedNumbers = createSelector(emailSendState, (state) => state.selectedNumbers);

export const emailSendModalSelectors = {
  currentStep,
  documentType,
  rows,
  selectedEmailTemplate,
  selectedTypeNumbers,
  documentNumbersInfo,
  selectedNumbers,
  emailPreviewModalData,
};
